import BaseAPI from '@/apis/base/baseApi';
import commonFn from '@/commons/commonFunction';
import {FormMultiPart, Stream} from '@/apis/base/httpclient';
class FileAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'File';
  controllerName = 'File';

  getJson(fileName) {
    let request = {
      url: [this.getAPIUrl(), 'json', fileName].join('/'),
    };

    return this.getAsync(request);
  }

  /**
   * lấy link gọi download file
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   * @param {*} tenant :Dữ liệu công ty nào
   */
  getDownloadLink(type, file, name, tenant) {
    let url = [this.getAPIUrl(), 'download', type.toString()];
    if (file) {
      if (tenant) {
        url.push(tenant);
      }

      url.push(file);

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * lấy link gọi file
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   */
  getFileLink(type, file, name, tenant) {
    let url = [this.getAPIUrl(), type.toString()];
    if (file) {
      if (tenant) {
        url.push(tenant);
      }

      url.push(file);

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * lấy link gọi file vào file đẩy lên theo tenant, database
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   * nvtoan2 13/07/2023
   */
  getDbDownFileLink(type, file, name, dataId) {
    let url = [this.getAPIUrl(), 'dbDown', type.toString()];
    if (file) {
      url.push(file);

      if (dataId) {
        url.push(dataId);
      }

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * Upload file
   * @param {*} file : File upload
   * @param {*} type : Loại file
   */
  upload(file, type) {
    let data = new FormData();
    data.append('file', file);
    if (type) {
      data.append('type', type);
    }

    let request = {
      url: this.getAPIUrl(),
      data: data,
    };

    return this.postAsync(request, false, true, FormMultiPart);
  }

  /**
   * upload file cùng tên truyền vào
   * @param {*} file
   * @param {*} type
   * @param {*} name
   * @returns
   * nvtoan2 13/07/2023
   */
  uploadWithName(file, type, name) {
    let data = new FormData();

    if (type) {
      data.append('type', type);
    }
    data.append('name', name);
    data.append('file', file);

    let request = {
      url: [this.getAPIUrl(), 'name'].join('/'),
      data: data,
    };

    return this.postAsync(request, false, true, Stream);
  }

  /**
   * Upload nhiều file
   * @param {*} files : File upload
   * @param {*} type : Loại file
   */
  uploads(files, type) {
    let data = new FormData();
    files.forEach(file => {
      data.append('file', file, file.name);
      // var reader = new FileReader();
      // reader.readAsText(file, "UTF-8");
      // reader.onload = function (evt) {
      //     console.log(evt.target.result);
      // }
      // reader.onerror = function (evt) {
      //     document.getElementById("fileContents").innerHTML = "error reading file";
      // }
    });
    if (type) {
      data.append('type', type);
    }

    let request = {
      url: [this.getAPIUrl(), 'multi'].join('/'),
      data: data,
    };

    return this.postAsync(request, false, true, FormMultiPart);
  }

  /**
   * lấy link gọi file
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} name : tên file server
   * @param {*} width : độ rộng ảnh
   * @param {*} height : chiều dài ảnh
   * @param {*} quantity : độ phân giải
   */
  getImageLink(type, name, width, height, quantity) {
    let url = [this.getAPIUrl(), 'image', type];
    if (name) {
      url.push(name);
      if (width) {
        url.push(width);
      }
      if (height) {
        url.push(height);
      }
    }
    let context = JSON.parse(commonFn.getLocalStorage('Context'));
    if (context.TenantID) {
      url.push(context.TenantID);
    }
    if (quantity) {
      url.push(quantity);
    }

    return url.join('/');
  }

  /**
   * Check xem file tồn tại không
   * @param {*} type
   * @param {*} dataId
   * @param {*} name
   * nvtoan2 13/07/2023
   */
  checkFileExist(type, dataId, fileName) {
    let request = {
      url: [this.getAPIUrl(), 'check-exist', type, fileName, dataId].join('/'),
    };
    return this.getAsync(request);
  }
}

export default new FileAPI();
